export async function readResponse(response) {
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    try {
      return await response.json();
    } catch {
      return null;
    }
  }
  return response.text();
}

export function responseMessage(payload, fallback) {
  if (typeof payload === "string" && payload.trim()) return payload;
  if (payload?.errors) return Object.values(payload.errors).flat().join(" ");
  return payload?.error || payload?.message || payload?.title || fallback;
}

export async function postJson(url, payload) {
  const response = await fetch(url, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  const data = await readResponse(response);
  return { response, data };
}
